import { useEffect } from 'react'

const DEFAULT_TITLE = 'Broadflow'

export function usePageTitle(title = DEFAULT_TITLE) {
  useEffect(() => {
    document.title = title
  }, [title])
}
